import styled from 'styled-components';

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  /* width: 90px; */
  margin-left: -15px;
  font-size: 12px;
  background-color: #0394fc;
  padding: 8px;
  border-radius: 10px;
  color: white;
  pointer-events: auto;
  transition: background-color 0.2s;
  height: 36px;

  &:hover {
    background-color: #007acc;
  }
`;
